package api.traak.user

enum class EmailUpdateResult {
  NoUser,
  NeedsRelogin,
  EmailAlreadyInUse,
  UnknownFailure,
  Success,
}
